// extracted by mini-css-extract-plugin
export var alertIcon = "_ty-0";